import React from "react"

export const Separator = (): JSX.Element => (
    <div className="separator-line is-dotted is-dimmed" />
)

export default Separator
